export default "__VITE_ASSET__BOcATBHv__"